import { siteContent } from "../../content/siteContent";

export function ForYou() {
  const { forYou } = siteContent;

  return (
    <aside
      id="para-ti"
      className="home-for-you"
      aria-labelledby="home-for-you-title"
    >
      <div className="home-for-you__heading">
        <p className="home-eyebrow">{forYou.eyebrow}</p>
        <h2 id="home-for-you-title">{forYou.title}</h2>
      </div>

      <ul className="home-for-you__list">
        {forYou.items.map((item) => (
          <li key={item}>
            <span className="home-for-you__mark" aria-hidden="true" />
            <p>{item}</p>
          </li>
        ))}
      </ul>

      <div className="home-for-you__reinforcement">
        <p className="home-eyebrow">El enfoque Evolution</p>
        <h3 aria-label={forYou.reinforcement.title}>
          {forYou.reinforcement.titleLines.map((line) => (
            <span key={line}>{line}</span>
          ))}
        </h3>
        <p className="home-for-you__reinforcement-text">
          {forYou.reinforcement.text}
        </p>
        <strong>{forYou.reinforcement.closing}</strong>
      </div>
    </aside>
  );
}
